<template>
  <div class="cookie-law-widget-wrapper">
    <div class="cookie-law-widget">
      <div class="cookie-law-message">
        <img src="@/assets/icons/cookie.png" />
        <p>
          <span class="main-text">
            We use cookies in the delivery of our services.</span
          >
          To learn about the cookies we use and information about your
          preferences and opt-out choices,
          <a class="link" @click.prevent="show_modal = true">
            <u> please click here </u></a
          >. By using our platform you agree to our use of cookies.
        </p>
      </div>
      <div class="actions">
        <button class="btn-decline" @click="onDecline">Decline</button>
        <button class="btn-allow" @click="onAllow">Allow</button>
      </div>
    </div>
    <div class="cookie-modal-overlay" v-if="show_modal">
      <div class="cookie-modal">
        <h1>This website uses cookies</h1>
        <p>
          We use cookies to improve user experience. Choose what cookies you
          allow us to use. You can read more about our Cookie Policy in our
          privacy policy
        </p>
        <ul>
          <li v-for="(item, index) in cookies_info" :key="index">
            <input
              type="checkbox"
              :id="'row_' + index"
              v-model="item.activated"
              @change="onChanged"
            />
            <label :for="'row_' + index">{{ item.label }}</label>
          </li>
        </ul>
        <div class="cookie-modal-footer">
          <button
            v-if="is_accepting_all"
            @click="saveSettings('all')"
            class="btn-accept"
          >
            Accept
          </button>
          <button
            @click="saveSettings('some')"
            v-if="!is_accepting_all"
            class="btn-accept"
          >
            Accept
          </button>
          <button @click="onDecline()" class="btn-decline">Decline</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "cookie-law-widget",
  components: {},
  props: {},
  data: () => {
    return {
      show_modal: false,
      is_accepting_all: true,
      cookies_info: [
        {
          activated: true,
          label: "Strictly Necessary",
        },
      ],
    };
  },
  watch: {},
  mounted() {},
  methods: {
    saveSettings(type) {
      let vm = this;
      if (type == "all") {
        vm.cookies_info.forEach((item) => {
          item.activated = true;
        });
      }
      vm.$localStorage.set("cookie:settings", JSON.stringify(vm.cookies_info));
      vm.onAllow();
    },
    onChanged() {
      let vm = this;
      vm.is_accepting_all = true;
      if (vm.cookies_info.map((item) => item.activated).includes(true)) {
        vm.is_accepting_all = false;
      } else {
        vm.is_accepting_all = true;
      }
    },
    onDecline() {
      let vm = this;
      vm.$localStorage.remove("cookie:settings");
      vm.$emit("decline");
    },
    onAllow() {
      let vm = this;
      if (!vm.cookies_info.map((item) => item.activated).includes(true)) {
        vm.saveSettings("all");
      }
      vm.$emit("allow");
    },
  },
};
</script>
<style lang="scss" scoped>
.cookie-law-widget-wrapper {
  .cookie-law-widget {
    position: fixed;
    bottom: 0px;
    left: 10%;
    right: 10%;
    z-index: 9999;
    background: #fff;
    display: flex;
    align-items: center;
    border-radius: 10px;
    .cookie-law-message {
      display: flex;
      align-items: center;
      padding: 20px;
      img {
        margin-right: 10px;
      }
      p {
        margin-bottom: 0px;
        .main-text {
          color: #1ba5a4;
        }
        .link {
        }
      }
    }
    .actions {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .btn-decline {
        background: transparent;
        height: 20px;
        color: #1ba5a4;
        border: none;
        margin-right: 20px;
      }
      .btn-allow {
        background: #1ba5a4;
        height: 35px;
        padding: 0px 30px;
        color: #fff;
        border: none;
        border-radius: 5px;
      }
    }
  }
  .cookie-modal-overlay {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 99999;
    background: rgba(0, 0, 0, 0.432);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    .cookie-modal {
      width: 428px;
      background: #fff;
      border-radius: 5px;
      padding: 40px;
      h1 {
        font-size: 30px;
      }
      ul {
        list-style: none;
        padding-left: 0px;
        li {
          margin-bottom: 10px;
          label {
            margin-left: 10px;
          }
        }
      }
      .cookie-modal-footer {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
        .btn-accept {
          width: 125px;
          height: 40px;
          background: #1ba5a4;
          border-radius: 20px;
          color: #fff;
        }
        .btn-decline {
          width: 125px;
          height: 40px;
          border: 1px solid #000;
          border-radius: 20px;
          color: #000;
        }
      }
    }
  }
}
</style>
